// extracted by mini-css-extract-plugin
module.exports = {"paper":"RowActionsMenu_paper__3M8zl","itemContent":"RowActionsMenu_itemContent__1Hlu6","itemLabel":"RowActionsMenu_itemLabel__3l3_9","danger":"RowActionsMenu_danger__3l2Id"};